import {commitMutation, type Environment, graphql} from 'react-relay'

import type {
  createMilestoneRelayMutation,
  createMilestoneRelayMutation$data,
} from './__generated__/createMilestoneRelayMutation.graphql'

export function commitCreateMilestoneMutation({
  environment,
  input,
  onError,
  onCompleted,
}: {
  environment: Environment
  input: {
    repositoryId: string
    title: string
  }
  onError?: (error: Error) => void
  onCompleted?: (response: createMilestoneRelayMutation$data) => void
}) {
  return commitMutation<createMilestoneRelayMutation>(environment, {
    mutation: graphql`
      mutation createMilestoneRelayMutation($input: CreateMilestoneInput!) @raw_response_type {
        createMilestone(input: $input) {
          milestone {
            closed
            closedAt
            dueOn
            id
            progressPercentage
            title
            url
          }
        }
      }
    `,
    variables: {input},
    onError: error => onError && onError(error),
    onCompleted: response => onCompleted && onCompleted(response),
  })
}
